import { Component, inject } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { ToggleItemTextVisibilityButtonComponent } from "@components/toggle-item-text-visibility-button/toggle-item-text-visibility-button.component";
import { ToggleLockButtonComponent } from "@components/toggle-lock-button/toggle-lock-button.component";
import { ToggleVisibilityButtonComponent } from "@components/toggle-visibility-button/toggle-visibility-button.component";
import { FloorplanState } from "@domain/project/floorplan/floorplan-state";
import { FloorplanZonesService } from "@project/floorplan-zones.service";
import { FloorplanMenuItemButtonsComponent } from "@project/floorplanner/floorplan-menu/fgds/floorplan-menu-item-buttons/floorplan-menu-item-buttons.component";
import { FloorplanService } from "@project/floorplanner/floorplan.service";
import { DraggedItemType, FloorplanDragDropService } from "@utils/floorplan-drag-drop.service";

@Component({
  selector: "app-operating-theatre-menu",
  imports: [
    UiKitModule,
    FloorplanMenuItemButtonsComponent,
    ToggleLockButtonComponent,
    ToggleVisibilityButtonComponent,
    ToggleItemTextVisibilityButtonComponent,
  ],
  templateUrl: "./operating-theatre-menu.component.html",
  styleUrl: "./operating-theatre-menu.component.scss",
})
export class OperatingTheatreMenuComponent {
  private floorplanService = inject(FloorplanService);
  private floorplanZonesService = inject(FloorplanZonesService);
  private dragDropService = inject(FloorplanDragDropService);

  protected floorplanState: FloorplanState;
  protected readonly tooltipText: string = $localize`:@@floorplan.monitoring.button.addOperatingTheatre:Add operating theatre`;

  constructor() {
    this.floorplanState = this.floorplanService.selectedFloorplan.floorplanState;
  }

  protected addOperatingTheatre() {
    this.floorplanZonesService.addOperatingTheatre();
  }

  protected dragOperatingTheatre() {
    this.dragDropService.setDragged({ type: DraggedItemType.OPERATING_THEATRE });
  }

  protected updateOperatingTheatresItemTextVisibility(visible: boolean) {
    this.floorplanState.updateOperatingTheatresItemTextVisibility(visible);
  }
}
